/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'virtual-service';
const componentName = 'delete-vs-dialog';
const prefix = `${moduleName}.${componentName}`;

export const deleteVirtualServiceHeader = `${prefix}.deleteVirtualServiceHeader`;
export const deleteConfirmMessage = `${prefix}.deleteConfirmMessage`;
export const deleteVsOnlyLabel = `${prefix}.deleteVsOnlyLabel`;
export const deleteVsObjectsLabel = `${prefix}.deleteVsObjectsLabel`;

export const ENGLISH = {
    [deleteVirtualServiceHeader]: 'Delete Virtual Service',
    [deleteConfirmMessage]: 'Do you want to keep referenced objects or delete them as well?',
    [deleteVsOnlyLabel]: 'Delete Virtual Service Only',
    [deleteVsObjectsLabel]: 'Delete Virtual Service and Referenced Objects',
};
